import $ from 'jquery';

window.$ = window.jQuery = $;

(function ($) {
  // Set variables
  let Isotope = require('isotope-layout'),
    chosen = require('chosen-js'),
    $window = $(window),
    $affiliateFilter = $('#affiliate-filter'),
    affiliateItemClass = '.affiliates-block-item',
    affiliateOverlayClass = '.affiliate-overlay';

  var resizeTimer,
    isotopeGrid = new Isotope('.affiliates-block--body', {
      itemSelector: affiliateItemClass,
      layoutMode: 'fitRows',
    });

  /**
   * Select change
   */
  $affiliateFilter.on('change', function (evt) {
    var selectedItemSlug = $(evt.target).find('option:selected').val(),
      targetClass = '' === selectedItemSlug ? '' : '.' + selectedItemSlug;

    // Filter items
    isotopeGrid.arrange({
      filter: targetClass,
    });
  });

  /**
   * Doc ready
   *
   * Trigger scroll evt on load, so the column is aligned even if the page is loaded halfway down.
   * Trigger resize so the dynamic class can be applied if needed.
   */
  $(document).ready(function () {
    $window.resize();
  });

  /**
   * Resize
   *
   * check for the changes window dimensions
   */
  $window.resize(function (e) {
    // Check if resizing is done, and do resize function if so.
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      resizeEvent();
    }, 200);
  });

  // resize function
  function resizeEvent(e) {
    $('.affiliates-block--body').trigger('reLayout');
  }
})($);

for (let link of document.querySelectorAll('.js-affiliates-block-item-link')) {
  link.addEventListener('click', (event) => {
    // Open modal only on desktop devices
    if (window.innerWidth < 1024) {
      return false;
    }
    event.preventDefault();
    let id = event.currentTarget.dataset.targetId;
    let target = document.querySelector(
      `.js-affiliates-block-modal[data-id='${id}']`
    );
    target.classList.add('wwffi-modal--visible');
  });
}

for (let link of document.querySelectorAll(
  '.js-affiliates-block-modal-close'
)) {
  link.addEventListener('click', (event) => {
    let id = event.currentTarget.dataset.targetId;
    let target = document.querySelector(
      `.js-affiliates-block-modal[data-id='${id}']`
    );
    target.classList.remove('wwffi-modal--visible');
  });
}
